import { Theme } from "./symbols";

export const redTheme: Theme = {
    name: 'red',
    properties: {
      '--background': '#831f1f',
      '--on-background': '#0F0F0F',
      '--primary': '#389BFF',
      '--on-primary': '#fff',
      '--secondary': '#B2B4B7',
      '--on-secondary': '#fff',
      '--surface': '#fff',
      '--on-surface': '#0F0F0F',
      '--error': '#EB5945',
      '--on-error': '#fff',
      '--warning': '#F6BB42',
      '--on-warning': '#fff',
      '--color': '#000',
      '--button-color': '#831f1f'
    },
    settings: {
      roundedButtons: false
    }
  };
